import { DesktopOutlined, MobileOutlined } from '@ant-design/icons';
import { Button } from 'antd';

interface Props {
  value: 'mobile' | 'pc';
  onChange: (value: 'mobile' | 'pc') => void;
}
const EndSwitch: React.FC<Props> = ({ value, onChange }) => {
  return (
    <Button
      type="primary"
      shape="circle"
      size="large"
      icon={value === 'mobile' ? <DesktopOutlined /> : <MobileOutlined />}
      onClick={() => onChange && onChange(value === 'mobile' ? 'pc' : 'mobile')}
      style={{
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
      }}
    />
  );
};
export default EndSwitch;
